import { render } from "./ItRisksView.vue?vue&type=template&id=6e4207be"
import script from "./ItRisksView.vue?vue&type=script&lang=js"
export * from "./ItRisksView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrateur\\Documents\\davca-cm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__